import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/more.png'
import _imports_2 from '@/assets/btn_1.png'
import _imports_3 from '@/assets/pc_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-22980045"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-48" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "more-icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "no_rem_nav_bg",
  src: _imports_2,
  alt: ""
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no_rem_80" }, null, -1))
const _hoisted_9 = { class: "bg-white no_rem_80 fixed ab-top z-999" }
const _hoisted_10 = { class: "no_rem_w_1200 mc no_rem_80 flex-row-center-sb" }
const _hoisted_11 = { class: "flex-row-center-start" }
const _hoisted_12 = ["onClick"]

import {
		ref,
		watch
	} from 'vue';
	import useStore from '../store';
	import {
		useRouter
	} from "vue-router";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

	const store = useStore;
	const router = useRouter();

	const enterPage = ref(0);
	const ishow = ref(false);
	const navIndex = ref(0);
	const nav = ref([{
		name: "首页",
		link: "/",
	}, {
		name: "关于番顺",
		link: "/about",
	}, {
		name: "产品展示",
		link: "/product",
	}, {
		name: "品牌动态",
		link: "/BrandDynamics",
	}, {
		name: "商家列表",
		link: "/UserList",
	}]);

	// 监听路由跳转
	watch(() => router.currentRoute.value.path, (newValue) => {
		nav.value.forEach((v, i) => {
			if (newValue == v.link) {
				navIndex.value = i;
			} else if (newValue == "/productInfo") {
				navIndex.value = 2;
			} else if (newValue == "/BrandDetails") {
				navIndex.value = 3;
			} else if (newValue == "/UserInfo") {
				navIndex.value = 4;
			}
		})
	}, {
		immediate: true
	})

	// 回到首页
	const backIndex = () => {
		router.push("/");
	};

	// 导航跳转
	const navClick = (v: any) => {
		if (store.state.is_phone) {
			ishow.value = false;
		}
		router.push(v.link);
	};

	// 移动端显示导航栏
	const showMenu = () => {
		enterPage.value = 1;
		ishow.value = !ishow.value;
	};

return (_ctx: any,_cache: any) => {
  return (_unref(store).state.is_phone)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", { class: "bg-white h-48 fixed ab-top z-1000" }, [
          _createElementVNode("div", { class: "h-48 flex-row-center-sb head-box" }, [
            _createElementVNode("img", {
              class: "logo",
              onClick: backIndex,
              src: _imports_0,
              alt: ""
            }),
            _createElementVNode("div", {
              class: "h-48 flex-row-center-center more-icon-area",
              onClick: showMenu
            }, _hoisted_4)
          ])
        ]),
        (ishow.value && enterPage.value == 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed nav-area z-100",
              onClick: showMenu
            }))
          : _createCommentVNode("", true),
        (enterPage.value == 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["fixed nav-area-01 animate__animated z-999", ishow.value ? 'animate__fadeInDown' : 'animate__fadeOutUp'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.value, (v, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "nav-item flex-row-center-center relative bg-white",
                  onClick: _withModifiers(($event: any) => (navClick(v)), ["stop"])
                }, [
                  (navIndex.value == i)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute all text-center", {'color-white': navIndex.value == i}])
                  }, _toDisplayString(v.name), 3)
                ], 8, _hoisted_5))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "no_rem_logo pointer",
              onClick: backIndex,
              src: _imports_3,
              alt: ""
            }),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.value, (v, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "no_rem_nav_item flex-row-center-center pointer animation relative",
                  onClick: ($event: any) => (navClick(v))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["no_rem_nav_bg animation", {'nav_active': navIndex.value == i}]),
                    src: _imports_2,
                    alt: ""
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute all flex-row-center-center", {'color-white': navIndex.value == i}])
                  }, _toDisplayString(v.name), 3)
                ], 8, _hoisted_12))
              }), 128))
            ])
          ])
        ])
      ]))
}
}

})